import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import PostBoard from "src/components/home/PostBoard";
import { RootState } from "src/store/store";
import { ListParam, defaultListParam } from "src/types/api/listParam";
import { getTodayView, getTodayViewRate, getRealView, getRealViewRate } from "src/api/MessageApi";

interface PostContainerProps {
    rowPerPage: number;
}

const PostContainer: React.FC<PostContainerProps> = ({ rowPerPage }) => {
    const [postcontents, setPostContents] = useState([]);
    const [curPage, setCurPage] = useState(null);
    const [isMore, setIsMore] = useState(true);
    const [date, setDate] = useState(null);
    const [hour, setHour] = useState(null);
    
    const postCategory = useSelector((state: RootState) => state.category.postCategoryId);
    const postTab = useSelector((state: RootState) => state.tab.postTab);
    const serviceType = useSelector((state: RootState) => state.session.serviceType);

    const fetchData = useCallback(async (params: ListParam) => {
        try {
            let response;
            if (postTab === "당일누적" && postCategory === 1) {
                response = await getTodayView(params);
            } else if (postTab === "당일누적" && postCategory === 0) {
                response = await getTodayViewRate(params);
            } else if (postTab === "실시간" && postCategory === 1) {
                response = await getRealView(params);
            } else if (postTab === "실시간" && postCategory === 0) {
                response = await getRealViewRate(params);
            }
            const newData = response?.data.list || [];
            const date = response?.data.param.yyyymmdd || '';
            const hour = response?.data.param.hour || '';

            if ( newData.length < rowPerPage ){
                setIsMore(false)
            } else {
                setIsMore(true)
            }
            if (params.curPage === 1) {
                setPostContents(newData);
                setHour(hour);
                setDate(date);
            } else {
                setPostContents((prevData) => [...prevData, ...newData]); 
            }
        } catch (error) {
            console.error("API 호출 실패:", error);
            if (params.curPage === 1) setPostContents([]);
        }
    },[rowPerPage, postTab, postCategory]);

    useEffect(() => { 
        setCurPage(null);
        const defaultParams = defaultListParam();
        defaultParams.rowPerPage= rowPerPage;
        defaultParams.service_type= serviceType;
        fetchData(defaultParams);
    }, [rowPerPage, fetchData, serviceType]);

    const handleLoadMore = async () => {
        try {
            const defaultParams = defaultListParam();
            const newPage = curPage === null ? 2 : curPage + 1;
            defaultParams.rowPerPage= rowPerPage;
            defaultParams.service_type= serviceType;
            defaultParams.curPage= newPage;
            defaultParams.yyyymmdd = date;
            defaultParams.hour = hour;
            await fetchData(defaultParams);
            setCurPage(newPage);
        } catch (error) {
            console.error("추가 데이터 로드 실패:", error);
        }
    };

    return (
        <PostBoard contents={postcontents} isMore={isMore} handleLoadMore={handleLoadMore} />
    );
};

export default PostContainer;
